<div
    #dayContainer
    class="w-full h-full relative"
    (windowResized)="onWindowResized($event)"
    (mousemove)="onMouseMove($event)"
    (mouseleave)="onMouseLeave()"
    (click)="onClickSelectSlot($event)">
    @if (sessionOutlineTop != null) {
        <fm-session-selector-outline
            class="absolute cursor-pointer"
            [ngStyle]="{ 'top.px': sessionOutlineTop }"
            [width]="dayColumnWidth"
            [sessionDuration]="sessionDuration"
            [sessionTime]="pointedAtSessionTime"
            [slotNumber]="slotNumber"
            [partnerAvailable]="pointedAtSessionInfo ? true : false" />
    }

    @for (timeslot of filteredPotentialPartnerData; track timeslot.sessionTime; let j = $index) {
        @if (timeslot.sessionTime < endOfDay && timeslot.sessionTime >= dayData.startOfDay) {
            <fm-available-partner-tile
                [partnerInfo]="timeslot"
                [validPartner]="timeslot.partner ? true : false"
                [sessionTime]="timeslot.sessionTime"
                [sessionDuration]="timeslot.sessionDuration"
                [profilePhoto]="timeslot.partner?.profilePhoto"
                [profileSlug]="timeslot.partner?.profileSlug"
                [isSaved]="timeslot.partner?.saved"
                [isQuietMode]="timeslot.partner?.preferences.quietMode.value"
                [hasDirectBookablePartner]="timeslot.hasDirectBookablePartner"
                [isSelectable]="sessionOutlineTop !== null"
                class="h-[48px] absolute rounded-lg"
                [ngStyle]="{
                    'top.px': ((timeslot.sessionTime - dayData.startOfDay) / fifteenMinsInMs) * 48,
                    'width.px': dayColumnWidth,
                    'left.px': 0,
                }" />
        }
    }
    @for (session of dayData.bookedSessionData; track session.sessionTime; let j = $index) {
        @if (session.sessionTime < endOfDay && session.sessionTime >= dayData.startOfDay) {
            <fm-booked-session-tile
                [sessionInfo]="session"
                [timezone]="timezone"
                [timeFormat]="timeFormat"
                [slotNumber]="(session.sessionTime - dayData.startOfDay) / fifteenMinsInMs"
                [width]="dayColumnWidth - 4"
                class="absolute rounded-lg"
                [ngStyle]="{
                    'top.px':
                        ((session.sessionTime - dayData.startOfDay) / fifteenMinsInMs) * 48 + 2,
                    'left.px': 2,
                }" />
        }
    }
    @for (
        selectedSession of dayData.selectedSessionData;
        track selectedSession.sessionTime;
        let j = $index
    ) {
        @if (
            selectedSession.sessionTime >= dayData.startOfDay &&
            selectedSession.sessionTime < endOfDay
        ) {
            <fm-selected-session-tile
                class="absolute rounded-xl"
                [sessionDuration]="selectedSession.sessionDuration"
                [sessionTime]="selectedSession.sessionTime"
                [slotNumber]="(selectedSession.sessionTime - dayData.startOfDay) / fifteenMinsInMs"
                [width]="dayColumnWidth"
                [ngStyle]="{
                    'top.px':
                        ((selectedSession.sessionTime - dayData.startOfDay) / fifteenMinsInMs) * 48,
                }"
                >SELECTED</fm-selected-session-tile
            >
        }
    }
    <!-- Current time indicator -->
    @if (isToday) {
        <div
            class="absolute w-full border-t border-b border-red left-0 right-0 z-100"
            [style.top]="timeLineTop"></div>
        <div
            class="absolute w-[3px] h-3 bg-red -left-[3px] z-100"
            [style.top]="timeLineAnchorTop"></div>
        <div
            class="absolute text-12 text-red font-semibold -left-[45px] z-100 bg-white"
            [style.top]="timeLineAnchorTop">
            {{
                currentTimeInMs | epochToTime: displayTimeFormat : timezone : timeFormat == '12hr'
            }}</div
        >
    }

    @for (slot of timeslots; track slot; let i = $index) {
        <div
            class="h-[48px] border-b border-latte border-dashed"
            [ngClass]="{ '!border-solid': i % 4 == 3, 'bg-oatmilk': isToday }"></div>
    }
</div>
